import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import EditEmployeeApi from '../../../api/services/Users/getEmployeeById.service';

const initialState = {
  value: {},
  loading: false,
  error: {},
};

interface MyData {
  id: any;
}

export const getEmployeeByIdCall = createAsyncThunk(
  'getEmployeeByIdCall',
  async (payload: MyData, { rejectWithValue }) => {
    try {
      const res = await EditEmployeeApi.getEmployeeById(payload);
      // 👇 Check API error flag
      if (res?.data?.error) {
        return rejectWithValue(res.data);
      }
      return res?.data?.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);

const getEmployeeById = createSlice({
  name: 'getEmployeeById',
  initialState,
  reducers: {
    savingEmployee: (state, action) => {
      state.value = { ...action.payload };
    },
    clearDataById: state => {
      state.value = {};
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getEmployeeByIdCall.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getEmployeeByIdCall.fulfilled, (state: any, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getEmployeeByIdCall.rejected, (state: any, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { savingEmployee, clearDataById } = getEmployeeById.actions;

export default getEmployeeById.reducer;
